import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Title as TitleUi } from '@/shared/uikit/Title';

export const Container = styled.div`
  background: ${COLORS.systemLight200};
  border-radius: 8px;
  gap: 12px;
  container-type: inline-size;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  padding-top: 12px;
  padding-inline: 12px;
  gap: 12px;

  @container (width < 374px) {
    justify-content: center;

    .btn-block {
      width: 100%;
    }
  }
`;

export const Title = styled(TitleUi)`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BtnBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SubInfo = styled.div`
  color: ${COLORS.systemDark200};
`;

export const List = styled.div`
  padding-inline: 4px;
  padding-bottom: 4px;
`;
